import Ad from '../components/Ad'
import PleaseSupportUs from '../components/PleaseSupportUs'
import classNames from 'classnames'
import { isPatron } from '../util/helpers'
import styles from '../styles/Leaderboard.module.scss'
import useCanRunAds from '../hooks/useCanRunAds'
import useDarkMode from 'use-dark-mode'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const Leaderboard = () => {
  const canRunAds = useCanRunAds()
  const darkMode = useDarkMode(false)
  const profile = useSelector((state) => state.firebase.profile)
  const [randomRoll, setRandomRoll] = useState(Math.random())

  if (isPatron(profile)) return null

  /*const ad =
    !canRunAds || randomRoll < 0.35 ? (
      <PleaseSupportUs always height={90} width={728} />
    ) : randomRoll < 0.65 ? (
      <Ad suffix={1} />
    ) : (
      <Ad suffix={2} />
    ) */
  const ad = <PleaseSupportUs height={90} width={728} />

  return (
    <div
      className={classNames(styles.leaderboard, {
        [styles.dark]: darkMode.value,
      })}
    >
      {ad}
    </div>
  )
}

export default Leaderboard
